import { useAuthQuery } from 'app/api_v2/auth/queries';
import { isInspector } from 'app/helpers/userRoles';
import React from 'react';
import { Navigate } from 'react-router-dom';

interface HasToBeInspectorGuardProps {
  children: React.ReactNode;
}

export const HasToBeInspectorGuard = (props: HasToBeInspectorGuardProps) => {
  const { children } = props;

  const { isSuccess, data } = useAuthQuery();

  if (isSuccess && !data) {
    return <Navigate to={'/auth/login'} />;
  }

  if (isSuccess && data && !isInspector(data)) {
    return <Navigate to={'/dashboard'} />;
  }

  if (isSuccess) {
    return <>{children}</>;
  }
  return null;
};

export default HasToBeInspectorGuard;
